import React from "react";
import { ResetPasswordForm } from "../../organisms/ResetPasswordForm";
import { Main } from "./elements";

const ResetPassword = ({ onSubmit, isLoading, validate }: any) => {
  return (
    <Main>
      <ResetPasswordForm
        onSubmit={onSubmit}
        isLoading={isLoading}
        validate={validate}
      />
    </Main>
  );
};

export default ResetPassword;
